// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_container__7yPMC {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  width: 100%;
  padding: 25px 80px;

  @media (max-width: 1024px) {
    padding: 20px;
  }
}

.style_header__YBATl {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 25px;
  gap: 1rem;

  @media (max-width: 550px) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
}

.style_header__YBATl .style_caption__DDjJy {
  @media (max-width: 750px) {
    width: 65%;
  }
}

.style_headerTitle__ap\\+yf {
  @media (max-width: 550px) {
    font-size: 1.2rem !important;
  }
}

.style_headerSubtitle__1dhAn {
  @media (max-width: 550px) {
    display: none;
  }
}

.style_tabs__3uS8P {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.style_searchHeader__VsS5U {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  width: 100%;
  gap: 1rem;

  @media (max-width: 900px) {
    flex-direction: column;
    align-items: stretch;
  }
}

.style_groupCounter__ExPZY {
  display: flex;
  flex-direction: column;
}

.style_searchBox__MBz9S {
  flex-shrink: 0;

  @media (max-width: 900px) {
    width: 100% !important;
    max-width: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/MachinesGroup/style.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,kBAAkB;;EAElB;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;EACnB,SAAS;;EAET;IACE,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,SAAS;;EAET;IACE,sBAAsB;IACtB,oBAAoB;EACtB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;;EAEd;IACE,sBAAsB;IACtB,0BAA0B;EAC5B;AACF","sourcesContent":[".container {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  height: 100%;\n  width: 100%;\n  padding: 25px 80px;\n\n  @media (max-width: 1024px) {\n    padding: 20px;\n  }\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  margin-bottom: 25px;\n  gap: 1rem;\n\n  @media (max-width: 550px) {\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n  }\n}\n\n.header .caption {\n  @media (max-width: 750px) {\n    width: 65%;\n  }\n}\n\n.headerTitle {\n  @media (max-width: 550px) {\n    font-size: 1.2rem !important;\n  }\n}\n\n.headerSubtitle {\n  @media (max-width: 550px) {\n    display: none;\n  }\n}\n\n.tabs {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.searchHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n  width: 100%;\n  gap: 1rem;\n\n  @media (max-width: 900px) {\n    flex-direction: column;\n    align-items: stretch;\n  }\n}\n\n.groupCounter {\n  display: flex;\n  flex-direction: column;\n}\n\n.searchBox {\n  flex-shrink: 0;\n\n  @media (max-width: 900px) {\n    width: 100% !important;\n    max-width: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `style_container__7yPMC`,
	"header": `style_header__YBATl`,
	"caption": `style_caption__DDjJy`,
	"headerTitle": `style_headerTitle__ap+yf`,
	"headerSubtitle": `style_headerSubtitle__1dhAn`,
	"tabs": `style_tabs__3uS8P`,
	"searchHeader": `style_searchHeader__VsS5U`,
	"groupCounter": `style_groupCounter__ExPZY`,
	"searchBox": `style_searchBox__MBz9S`
};
export default ___CSS_LOADER_EXPORT___;
